/*import logo from './logo.svg';
import './App.css';
import PersonList from './components/PersonList.js'; */

import React, { Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { UserProvider } from "./context/UserContext";

import { GlobalHistory } from "./components/GlobalHistory";
import Layout from "./components/layout/Layout";
import Landing from "./pages/Landing";
import { ProtectedRoute } from "./routes/protected.route";

import About from "./pages/About";
import Privacy from "./pages/Privacy";
import TOS from "./pages/TOS";
import Brainteasers from "./pages/Brainteasers";
import ProjectBasedLearning from "./pages/ProjectBasedLearning";
import Online from "./pages/Online";
import CaseStudies from "./pages/CaseStudies";
import HackingCreativity from "./pages/HackingCreativity";
import Team from "./pages/Team";
import OrgAssessment from "./pages/OrgAssessment";
import Tldllv from "./pages/Tldllv";
import Speaking from "./pages/Speaking";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Project from "./pages/Project";
import ProblemList from "./pages/ProblemList";
import SubmitSolution from "./pages/SubmitSolution";
import ResetPassword from "./pages/ResetPassword";
import { ProblemProvider } from "./context/ProblemContext";


 const App = () => {

	return (
		<UserProvider>
			<ProblemProvider>
				<BrowserRouter>
					<GlobalHistory />
						<Layout>
							<Routes>
								<Route element={<ProtectedRoute />}>
									<Route path="/home" element={<Home />} />
									<Route path="/project/:problemtypeid" element={<Project />} />
									<Route path="/problem/list/:problemtypeid" element={<ProblemList />} />
									<Route path="/solution/problem/:problemid" element={<SubmitSolution />} />
								</Route>
								

								<Route path="/" element={<Landing />} />
								<Route path="/login" element={<Login />} />
								<Route path="/about" element={<About />} />
								<Route path="/privacy" element={<Privacy />} />
								<Route path="/tos" element={<TOS />} />
								<Route path="/brainteasers" element={<Brainteasers />} />
								<Route path="/pbl" element={<ProjectBasedLearning />} />
								<Route path="/online" element={<Online />} />
								<Route path="/casestudies" element={<CaseStudies />} />
								<Route path="/hackingcreativity" element={<HackingCreativity />} />
								<Route path="/team" element={<Team />} />
								<Route path="/orgassessment" element={<OrgAssessment />} />
								<Route path="/tldllv" element={<Tldllv />} />
								<Route path="/speaking" element={<Speaking />} />
								<Route path="/reset-password" element={<ResetPassword />} />
							</Routes>
						</Layout>
					
				</BrowserRouter>
			</ProblemProvider>
		</UserProvider>
	);

	
 };

export default App; 

